import { createContext, useContext, useState } from 'react';

const ChatHeader = {
    chat_id: '',
    header: '',
    timestamp: '',
}

const ChatHeadersContextType = {
    chatHeaders: [],
    setChatHeaders: (headers) => { },
    appendChatHeaders: (headers) => { },
    getChatHeader: (chatId) => { },
    hasMore: false,
    setHasMore: (hasMore) => { },
    currentPage: 1,
    setCurrentPage: (page) => { },
    isLoading: false,
    setIsLoading: (loading) => { },
}

const ChatHeadersContext = createContext(ChatHeadersContextType);

export const ChatHeadersProvider = ({ children }) => {
    const [chatHeaders, setChatHeaders] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    const getChatHeader = (chatId) => {
        const chat = chatHeaders.find(header => header.chat_id === chatId);
        return chat ? chat.header.replace(/"/g, '') : null;
    };

    const appendChatHeaders = (newHeaders) => {
        setChatHeaders(prev => {
            // Avoid duplicates by filtering out headers with existing chat_ids
            const existingIds = new Set(prev.map(header => header.chat_id));
            const uniqueNewHeaders = newHeaders.filter(header => !existingIds.has(header.chat_id));
            return [...prev, ...uniqueNewHeaders];
        });
    };

    const updateChatHeader = (chatId, header) => {
        setChatHeaders(prev => {
            const existingIndex = prev.findIndex(chat => chat.chat_id === chatId);
            if (existingIndex !== -1) {
                // Update existing header
                const updated = [...prev];
                updated[existingIndex] = { ...updated[existingIndex], header };
                return updated;
            } else {
                // Add new header
                const newHeader = {
                    chat_id: chatId,
                    header,
                    timestamp: new Date().toISOString()
                };
                return [newHeader, ...prev];
            }
        });
    };

    return (
        <ChatHeadersContext.Provider
            value={{
                chatHeaders,
                setChatHeaders,
                appendChatHeaders,
                getChatHeader,
                updateChatHeader,
                hasMore,
                setHasMore,
                currentPage,
                setCurrentPage,
                isLoading,
                setIsLoading,
            }}
        >
            {children}
        </ChatHeadersContext.Provider>
    );
};

export const useChatHeadersContext = () => {
    const context = useContext(ChatHeadersContext);
    if (context === undefined) {
        throw new Error('useChatHeadersContext must be used within a ChatHeadersProvider');
    }
    return context;
};

export { ChatHeader };     